<template>
  <transition name="fade">
    <div v-if="!active" class="ai-practice-toggle-wrapper">
      <div class="attention-finger-bubble">
        <div class="practice-glow-text">실습을 꼭 해보세요!</div>
        <span class="attention-finger">👇</span>
      </div>
      <button
          class="ai-practice-toggle practice-cta-animate"
          @click="togglePractice"
          title="실습 모드를 켭니다"
      >
        <i class="fas fa-robot"></i>
        프롬프트 실습
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LLMPracticeToggle',
  emits: ['toggle'],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const togglePractice = () => {
      emit('toggle', !props.active);
    }
    return {togglePractice};
  }
}
</script>

<style scoped>
.ai-practice-toggle-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.attention-finger-bubble {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -60px; /* 더 위로 올림 */
  z-index: 10000;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.practice-glow-text {
  color: #FFD600;
  font-size: 1.15rem;
  font-weight: 900;
  margin-bottom: 12px;
  letter-spacing: 0.01em;
  text-shadow:
      0 0 8px #FFD600,
      0 0 16px #FFD60099,
      0 2px 4px #3338;
  animation: glowText 2.2s ease-in-out infinite;
  user-select: none;
}

@keyframes glowText {
  0%, 100% {
    text-shadow:
        0 0 8px #FFD600,
        0 0 16px #FFD60099,
        0 2px 4px #3338;
    opacity: 1;
  }
  50% {
    text-shadow:
        0 0 18px #FFD600,
        0 0 32px #FFD600cc,
        0 2px 8px #333a;
    opacity: 0.85;
  }
}

.attention-finger {
  font-size: 2.5em;
  color: #6366f1;
  filter: drop-shadow(0 2px 6px #a5b4fc);
  animation: fingerPress 1.2s infinite;
  user-select: none;
}

@keyframes fingerPress {
  0%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(8px) scale(1.1);
  }
  40% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(8px) scale(1.1);
  }
  80% {
    transform: translateY(0);
  }
}

.ai-practice-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 28px;
  padding: 24px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 3px 16px 4px #6366f1, 0 0 32px 8px #a5b4fc;
  transition: all 0.25s ease;
  position: relative;
  animation: pulse 1.2s infinite;
}

.ai-practice-toggle:hover {
  transform: translateY(-1px) scale(1.05);
  box-shadow: 0 5px 24px 8px #6366f1, 0 0 48px 12px #a5b4fc;
}

.i-practice-toggle i {
  font-size: 18px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 16px 4px #6366f1, 0 0 32px 8px #a5b4fc;
  }
  50% {
    box-shadow: 0 0 32px 12px #a5b4fc, 0 0 48px 16px #6366f1;
  }
  100% {
    box-shadow: 0 0 16px 4px #6366f1, 0 0 32px 8px #a5b4fc;
  }
}
@keyframes fadeInOut {
  0%, 100% {
    opacity: 0;
  }
  10%, 90% {
    opacity: 1;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>



<!--<template>-->
<!--  <transition name="fade">-->
<!--    <button-->
<!--        v-if="!active"-->
<!--        class="ai-practice-toggle"-->
<!--        @click="togglePractice"-->
<!--        title="실습 모드를 켭니다"-->
<!--    >-->
<!--      <i class="fas fa-robot"></i>-->
<!--      프롬프트 실습-->
<!--    </button>-->
<!--  </transition>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: 'LLMPracticeToggle',-->
<!--  emits: ['toggle'],-->
<!--  props: {-->
<!--    active: {-->
<!--      type: Boolean,-->
<!--      default: false-->
<!--    }-->
<!--  },-->
<!--  setup(props, { emit }) {-->
<!--    const togglePractice = () => {-->
<!--      emit('toggle', !props.active);-->
<!--    }-->

<!--    return { togglePractice };-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--.ai-practice-toggle {-->
<!--  position: fixed;-->
<!--  bottom: 20px;-->
<!--  right: 20px;-->
<!--  z-index: 9999;-->

<!--  display: flex;-->
<!--  align-items: center;-->
<!--  gap: 10px;-->

<!--  background: #007bff; /* 기본 파랑 */-->
<!--  color: white;-->
<!--  border: none;-->
<!--  border-radius: 28px;-->

<!--  padding: 24px 32px;-->
<!--  font-size: 16px;-->
<!--  font-weight: 600;-->

<!--  cursor: pointer;-->
<!--  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);-->
<!--  transition: all 0.25s ease;-->
<!--}-->

<!--.ai-practice-toggle:hover {-->
<!--  transform: translateY(-1px);-->
<!--  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.25);-->
<!--}-->

<!--.ai-practice-toggle i {-->
<!--  font-size: 18px;-->
<!--}-->

<!--/* Fade transition */-->
<!--.fade-enter-active, .fade-leave-active {-->
<!--  transition: opacity 0.4s ease;-->
<!--}-->
<!--.fade-enter-from, .fade-leave-to {-->
<!--  opacity: 0;-->
<!--}-->
<!--</style>-->